import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { SendTypes, UseTypes } from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { UpdateP2PScheduledMessageCommand } from '../../../../core/api/models/update-p-2-p-scheduled-message-command';
import { ScheduledMessagesService } from '../../../../core/api/services/scheduled-messages.service';
import { DateTimeConfig } from '../../../../shared/components/date-time-picker/date-time-picker.component';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';

@Component({
    selector: 'app-edit-send-p2p-sms',
    templateUrl: './edit-send-p2p-sms.component.html',
    styleUrls: ['./edit-send-p2p-sms.component.scss'],
    standalone: false
})
export class EditSendP2pSmsComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  model: UpdateP2PScheduledMessageCommand = {};
  directDateTimeConfig: DateTimeConfig;
  get SendTypes() {
    return SendTypes;
  }
  get UseTypes() {
    return UseTypes;
  }
  isCanSendFlashSms: boolean = false;

  //#endregion

  constructor(
    protected currentService: ScheduledMessagesService,

    private dialogRef: MatDialogRef<EditSendP2pSmsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    if (data.model) this.model = data.model;
  }

  ngOnInit() {
    try {
      this.initForm();
      this.formPageConfig.title = 'pages.sendP2pSms.editTitle';
      this.configBaseSendSMS();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  initForm() {
    this.form = new FormGroup({
      senderNumberId: new FormControl('', Validators.required),
      sendDate: new FormControl('', Validators.required),
      sendTime: new FormControl('', Validators.required),
      description: new FormControl(''),
      isFlashSms: new FormControl(''),
    });
  }
  configBaseSendSMS() {
    try {
      this.directDateTimeConfig = {
        dateLabel: 'common.sendDay',
        timeLabel: 'common.sendHour',
        dateFormControl: this.form?.get('sendDate') as FormControl,
        timeFormControl: this.form?.get('sendTime') as FormControl,
        responsiveClassName: 'md:tw-w-1/2',
        minDateType: 'today',
        dateTimeValue: this.model.dateTimeNext,
        isEditMode: this.formPageConfig.isEditMode,
      };
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  //#region Api

  //Update
  baseUpdateApi() {
    this.unSubs();
    this.loading = true;
    this.currentService
      .scheduledMessagesUpdateP2PScheduledMessagePut({ body: this.model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  onSubmit() {
    if (!this.isValidForm(this.form, this.tagName)) return;
    this.baseUpdateApi();
  }

  onClose() {
    this.dialogRef.close();
  }

  onSuccess() {
    this.dialogRef.close(true);
    this.unSubs();
  }
}
